import apiClient from "@/api/client";
import type {
  Tenant,
  TenantQuota,
  TenantCreatePayload,
  TenantUpdatePayload,
} from "@/types";

export async function getTenants(): Promise<Tenant[]> {
  const { data } = await apiClient.get<Tenant[]>("/tenants");
  return data;
}

export async function getTenant(id: string): Promise<Tenant> {
  const { data } = await apiClient.get<Tenant>(`/tenants/${id}`);
  return data;
}

export async function createTenant(
  payload: TenantCreatePayload
): Promise<Tenant> {
  const { data } = await apiClient.post<Tenant>("/tenants", payload);
  return data;
}

export async function updateTenant(
  id: string,
  payload: TenantUpdatePayload
): Promise<Tenant> {
  const { data } = await apiClient.put<Tenant>(`/tenants/${id}`, payload);
  return data;
}

export async function getTenantQuota(tenantId: number | string): Promise<TenantQuota> {
  const { data } = await apiClient.get<TenantQuota>(
    `/tenants/${tenantId}/quota`
  );
  return data;
}

export interface ProvisionStatus {
  status: string;
  id?: number | string;
  path?: string;
  error?: string;
}

export interface ReprovisionReport {
  tenant_id: number;
  slug: string;
  netbox: ProvisionStatus;
  keycloak: ProvisionStatus;
  vault: ProvisionStatus;
}

export async function reprovisionTenant(id: number): Promise<ReprovisionReport> {
  const { data } = await apiClient.post<ReprovisionReport>(
    `/tenants/${id}/reprovision`,
  );
  return data;
}

export interface DeleteTenantReport {
  tenant_id: number;
  slug: string;
  vm_cascaded: number;
  keycloak?: string;
  netbox?: string;
  status: string;
}

export async function deleteTenant(
  id: number,
  force: boolean = false,
): Promise<DeleteTenantReport> {
  const { data } = await apiClient.delete<DeleteTenantReport>(
    `/tenants/${id}`,
    { params: force ? { force: true } : undefined },
  );
  return data;
}
